import React, { useState } from 'react';
import { TestCycleToolbar } from '../../ui/primitives/ActionToolbar';
import CloneTestCycleModal from '../../components/project-dashboard/test-cycles/CloneTestCycleModal';
import { deleteTestCycle } from '../../modules/testcycles';
import { deletionIssues } from '../../components/project-dashboard/test-cycles/static-data';
import ConfirmationModal from '../../ui/primitives/ConfirmationModal';
import { Stack, Typography } from '@mui/material';

const TestCycleTableActions = ({
  handleOpenTestCycleModal,
  selectedItems = [],
  isSelectedItems,
  selectedRows = [],
  addNotification,
  refreshData,
  pendingAction,
  setPendingAction,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);

  const handleDelete = async () => {
    const ids = pendingAction?.row
      ? [pendingAction.row.id]
      : selectedItems;
    try {
      await deleteTestCycle({ testcycles: ids });
      refreshData();
      addNotification('success', 'Test cycle(s) deleted successfully!');
      setShowDeleteModal(false);
      setPendingAction(null);
    } catch (error) {
      addNotification('danger', error?.message ?? 'Failed to delete test cycle. Please try again later.');
    }
  };

  return (
    <>
      <TestCycleToolbar
        onAdd={handleOpenTestCycleModal}
        onClone={() => setShowCloneModal(true)}
        onDelete={() => setShowDeleteModal(true)}
        isSelectedItems={isSelectedItems}
      />

      <ConfirmationModal
        show={showDeleteModal || pendingAction?.type === 'delete'}
        handleClose={() => {
          setShowDeleteModal(false);
          setPendingAction(null);
        }}
        handleConfirm={handleDelete}
        title="Remove Test Cycle"
        body={
          <Stack direction="column" spacing={1}>
            <Typography>Removing the test cycle(s) will permanently remove the following:</Typography>
            <Typography component="ul">
              {deletionIssues.map((issue, index) => (
                <li key={index}>{issue}</li>
              ))}
            </Typography>
            <Typography>This action cannot be undone.</Typography>{' '}
            <strong>Are you sure you want to delete the test cycle(s)?</strong>
          </Stack>
        }
        buttonLabel="Delete"
      />

      <CloneTestCycleModal
        show={showCloneModal || pendingAction?.type === 'clone'}
        handleClose={() => {
          setShowCloneModal(false);
          setPendingAction(null);
        }}
        entityToClone={selectedRows[0] || pendingAction?.row}
        fetchTestCycles={refreshData}
      />
    </>
  );
};

export default TestCycleTableActions;